import React, { useState, useContext, useEffect } from "react";
import { connect } from "dva";
import { hot } from "react-hot-loader";
const lodash = require("lodash");

import {
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  message,
  notification,
  Row,
  Select,
  Tag,
  Tooltip,
  Spin,
  Skeleton
} from "antd";
import TestSuiteInput from "../../TestCaseAdd/TestSuiteInput";
import TestCaseTagInput from "../../TestCaseAdd/TestCaseTagInput";
import { AppContext } from "../../../AppContext";
import {
  TestCasesApi,
  CustomFieldsApi,
  CustomField,
  ProjectUsersApi
} from "../../../services/generated-sdk";
import { handleError } from "../../../utils/common";
import { BulkActionResult } from "../../../services/generated-sdk";
import ShowQueueStatus from "../../common/ShowQueueStatus";

import { customFieldToAnt } from "../../../utils/custom-field-handler";
import { getFormItem } from "../../../utils/form-handler";
import RequirementAutocomplete from "../../requirements/RequirementAutocomplete";

enum Status {
  ENABLED = 1,
  DISABLED = 0
}
const formItemLayout = {
  labelCol: {
    lg: { span: 9 },
    xs: { span: 24 },
    sm: { span: 24 }
  },
  wrapperCol: {
    lg: { span: 15 },
    xs: { span: 24 },
    sm: { span: 24 }
  }
};

function TestCaseBulkEditFormStatic(props) {
  const [formItemsStatus, setItemsStatus] = useState({
    priority: Status.ENABLED,
    suite: Status.ENABLED,
    tags: Status.ENABLED,
    overwriteTags: Status.DISABLED,
    overwriteRequirements: Status.DISABLED
  });
  const { company, projectId, planDetails, requirementsEnabled } = useContext(
    AppContext
  );
  const [tags, setTags] = useState<Array<string>>([]);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);
  const [actionResult, setActionResult] = useState<BulkActionResult>(null);
  const [customFields, setCustomFields] = React.useState<CustomField[]>([]);
  const [loadingCustomFields, setloadingCustomFields] = useState(false);

  // if (
  //   !(
  //     history &&
  //     history.location &&
  //     history.location.state &&
  //     history.location.state.query &&
  //     history.location.state.query.ids
  //   )
  // ) {
  //   history.push(`/project/${props.projectId}/manage`);
  //   return null;
  // }
  // const testCaseIds = history.location.state.query.ids;
  const testCaseIds = props.testCaseIds;

  useEffect(() => {
    fetchCustomFields();
  }, []);

  const fetchCustomFields = async () => {
    setloadingCustomFields(true);
    let api = new CustomFieldsApi();

    try {
      const cfs = await api.getCustomFields({
        company: company ? company.id : null,
        filter: JSON.stringify({
          projects: projectId,
          entity: "TestCase"
        }),
        sort: "sort_order"
      });
      await setCustomFields(cfs);
      setloadingCustomFields(false);
    } catch (e) {
      setloadingCustomFields(false);
      handleError(e.status);
    }
  };

  const changeFormItemStatus = (key: string) => {
    setItemsStatus({
      ...formItemsStatus,
      [key]:
        formItemsStatus[key] === Status.ENABLED
          ? Status.DISABLED
          : Status.ENABLED
    });
  };

  const handleSubmit = async e => {
    e.preventDefault(e);
    if (isSubmitDisabled) {
      return;
    }
    props.form.validateFieldsAndScroll(async (err, field) => {
      let st = field;
      // console.log({ err, st, field });
      if (!err) {
        //handle customFields
        let customFieldsData = customFields.map(async cf => {
          let valueLabel = "";
          let color = "";
          if (field[cf.name] != undefined) {
            const value = field[cf.name];
            delete field[cf.name];
            if (cf.type === "dropdown" || cf.type == "multipleSelect") {
              if (value && Array.isArray(value)) {
                valueLabel = value
                  .map(v => {
                    let opt = cf.extra.options.find(
                      o => o && o.systemValue == v
                    );
                    if (opt) {
                      return opt.label;
                    }
                    return "";
                  })
                  .join(",");
              } else {
                let opt = cf.extra.options.find(
                  o => o && o.systemValue == value
                );
                if (opt) {
                  valueLabel = opt.label;
                  // color = opt.color;
                }
              }
              // cf.extra.options.map(o => {
              //   if (o.systemValue == value) {
              //     valueLabel = o.label;
              //     // color = o.color;
              //   }
              // });
            }
            if (cf.type === "user") {
              const API = new ProjectUsersApi();
              try {
                let result = await API.getProjectUsers({
                  project: projectId,
                  filter: JSON.stringify({ user_contains: value })
                });
                if (result) {
                  const pUser = result[0];
                  valueLabel = pUser && pUser.user ? pUser.user.name : "NA";
                }
              } catch (e) {
                handleError(e.status);
              }
            }
            if (cf.type === "date") {
              valueLabel = value.format("YYYY-MM-DD");
            }
            return {
              id: cf.id,
              name: cf.name,
              value,
              label: cf.label,
              valueLabel,
              color
            };
          } else {
            return null;
            //  Do not select those custom fields which have no data
            // let value = null;
            // return {
            //   id: cf.id,
            //   name: cf.name,
            //   value,
            //   label: cf.label,
            //   valueLabel,
            //   color
            // };
          }
        });
        const cfs = await Promise.all(customFieldsData);
        field["customFields"] = cfs.filter(cf => cf != null);

        const payload = lodash.assign(
          field,
          formItemsStatus.tags === Status.ENABLED ? { tags } : null
        );

        // const hide = message.loading("Updating...", 0);
        setSubmitDisabled(true);
        const API = new TestCasesApi();
        try {
          let result = await API.quickUpdateTestCases({
            project: props.projectId,
            testCaseQuickUpdatePayload: {
              testcases: testCaseIds,
              overwriteTags: formItemsStatus.overwriteTags === Status.ENABLED,
              overwriteRequirements:
                formItemsStatus.overwriteRequirements === Status.ENABLED,
              ...payload
            }
          });
          // let result = await API.quickUpdateTestCases({
          //   project: props.projectId,
          //   testCaseQuickUpdatePayload: {
          //     overwriteTags: formItemsStatus.overwriteTags === Status.ENABLED,
          //     testcases: testCaseIds.map(id => ({
          //       id,
          //       ...payload
          //     }))
          //   }
          // });
          // console.log({ result });
          setActionResult(result);
          if (result && result.status) {
            if (result.queue && result.queue.id) {
              console.log("queue in response.......");
              return;
            } else {
              // hide();
              notification["success"]({
                message: "Done",
                description: "Successfully edited"
              });
              setSubmitDisabled(false);
              //history.goBack();
              // history.push(`/project/${props.projectId}/manage`);
              window.location.reload();
            }
          } else {
            // hide();
            notification["error"]({
              message: "Error",
              description: result.message
            });
            setSubmitDisabled(false);
          }
        } catch (e) {
          console.log({ e });
          // hide();
          setSubmitDisabled(false);
          e.json().then(({ message }) => {
            console.log({ ERR_MSG: message });
            handleError(e.status, {}, message);
          });
        }
      }
    });
  };

  const onQueueComplete = () => {
    console.log("onQueueComplete.....................");
    if (props.onComplete) {
      props.onComplete();
      return;
    }
    // //setActionResult(null);
    // //setSubmitDisabled(false);
    // //history.goBack();
    // history.push(`/project/${props.projectId}/manage`);
    window.location.reload();
  };

  const { getFieldDecorator } = props.form;
  const tagsAllowed = lodash.get(
    lodash.find(lodash.get(planDetails, "features", []), { name: "tags" }),
    "allowed"
  );

  // if (actionResult && actionResult.queue && actionResult.queue.id) {
  //   return (
  //     <div className="bulk-action message-container">
  //       <ShowQueueStatus
  //         queueId={actionResult.queue.id}
  //         onComplete={onQueueComplete}
  //         showProgressOnly={true}
  //       />
  //     </div>
  //   );
  // }

  return (
    <div>
      {/* {actionResult && actionResult.queue && actionResult.queue.id ? (
        <div className="bulk-action message-container">
          <ShowQueueStatus
            queueId={actionResult.queue.id}
            onComplete={onQueueComplete}
            showProgressOnly={true}
          />
        </div>
      ) : ( */}
      {actionResult && actionResult.queue && actionResult.queue.id ? (
        <div>
          <Row
            gutter={24}
            style={{ marginLeft: "auto", marginRight: "auto" }}
            className="bulkactions"
          >
            <Col span={24}>
              <div className="bulk-action tray">
                <Row>
                  <Col span={5}>
                    <Spin />
                  </Col>
                  <Col span={19}>
                    <ShowQueueStatus
                      queueId={actionResult.queue.id}
                      onComplete={onQueueComplete}
                      showProgressOnly={true}
                      progressType="line"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      ) : null}
      <div>
        <h2>Edit {testCaseIds.length} Test Cases</h2>
        <Form
          labelAlign={"left"}
          className="form-fullwidth bulkedit"
          layout="vertical"
          onSubmit={handleSubmit}
        >
          <Form.Item
            {...formItemLayout}
            label={
              <>
                {/* <Checkbox
                    onChange={() => changeFormItemStatus("suite")}
                    style={{ marginRight: "5px" }}
                    defaultChecked={formItemsStatus.suite === Status.ENABLED}
                  /> */}
                Suite
              </>
            }
          >
            {(formItemsStatus.suite === Status.ENABLED &&
              getFieldDecorator("suite")(
                <TestSuiteInput
                  projectId={props.projectId}
                  disabled={isSubmitDisabled}
                />
              )) || <Select disabled={true} />}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label={
              <>
                {/* <Checkbox
                    onChange={() => changeFormItemStatus("priority")}
                    style={{ marginRight: "5px" }}
                    defaultChecked={formItemsStatus.priority === Status.ENABLED}
                  /> */}
                Priority
              </>
            }
          >
            {(formItemsStatus.priority === Status.ENABLED &&
              getFieldDecorator("priority", {
                rules: []
              })(
                <Select
                  placeholder="Select Priority"
                  style={{ width: "240px" }}
                  disabled={isSubmitDisabled}
                >
                  <Select.Option value={0}>Low</Select.Option>
                  <Select.Option value={1}>Normal</Select.Option>
                  <Select.Option value={2}>High</Select.Option>
                </Select>
              )) || <Select disabled={true} />}
          </Form.Item>
          {getFieldDecorator("tags", {
            rules: []
          })(<Input hidden={true} />)}
          <Row>
            <Col lg={9} sm={24} xs={24}>
              {/* <Checkbox
                  onChange={() => changeFormItemStatus("overwriteTags")}
                  style={{ marginRight: "5px" }}
                  defaultChecked={formItemsStatus.tags === Status.ENABLED}
                /> */}
              Tags
            </Col>
            <Col lg={15} sm={24} xs={24}>
              <TestCaseTagInput
                projectId={projectId}
                onChange={values => {
                  //console.log({ values });
                  setTags(values);
                }}
                tagsEnabled={tagsAllowed}
                disabled={isSubmitDisabled}
              />
            </Col>
          </Row>
          <Row style={{}}>
            <Col lg={15} sm={24} xs={24} offset={9}>
              <Form.Item>
                <Checkbox
                  onChange={() => changeFormItemStatus("overwriteTags")}
                  style={{ marginRight: "5px" }}
                  defaultChecked={
                    formItemsStatus.overwriteTags === Status.ENABLED
                  }
                  disabled={isSubmitDisabled}
                />
                Overwrite existing tags
              </Form.Item>
            </Col>
          </Row>

          {requirementsEnabled ? (
            <div>
              <Form.Item
                label="Requirements"
                key="requirements"
                className="req_bulkupdate"
              >
                {getFieldDecorator("requirements", {})(
                  <RequirementAutocomplete
                    projectId={projectId}
                    requirementsEnabled={requirementsEnabled}
                    disabled={isSubmitDisabled}
                    // requirements={context.requirements}
                  />
                )}
              </Form.Item>
              <Row style={{}}>
                <Col lg={15} sm={24} xs={24} offset={9}>
                  <Form.Item>
                    <Checkbox
                      onChange={() =>
                        changeFormItemStatus("overwriteRequirements")
                      }
                      style={{ marginRight: "5px" }}
                      defaultChecked={
                        formItemsStatus.overwriteRequirements === Status.ENABLED
                      }
                      disabled={
                        !requirementsEnabled
                          ? true
                          : isSubmitDisabled ? true : false
                      }
                    />
                    Overwrite existing requirements
                  </Form.Item>
                </Col>
              </Row>
            </div>
          ) : null}

          {loadingCustomFields ? (
            <Skeleton />
          ) : (
            <Row className="cf_edit">
              {customFields.map(cf => (
                <Col
                  className="gutter-row"
                  span={cf.type == "textarea" || cf.type == "editor" ? 24 : 24}
                >
                  {getFormItem(
                    customFieldToAnt(
                      {
                        ...cf,
                        isRequired: false,
                        defaultValue: null
                      },
                      projectId,
                      company
                    ),
                    "",
                    getFieldDecorator
                  )}
                </Col>
              ))}
            </Row>
          )}
          <Button
            key="submit"
            htmlType="submit"
            type="primary"
            className="btn-success"
            style={{ float: "right" }}
            disabled={isSubmitDisabled}
          >
            Update
          </Button>
          <br />
          {/* <div style={{ clear: "both" }} /> */}
        </Form>
      </div>
      {/* )} */}
    </div>
  );
}
// export default Form.create()(TestCaseBulkEdit);

const TestCaseBulkEditWrapper = Form.create({ name: "bulk_edit_case_page" })(
  TestCaseBulkEditFormStatic
);

function mapStateToProps(state, ownProps) {
  return {
    app: state.app,
    ...ownProps
  };
}

const TestCaseBulkEdit = connect(mapStateToProps)(TestCaseBulkEditWrapper);

export default hot(module)(TestCaseBulkEdit);
